import { action, observable } from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";

export default class workbenchState extends baseState {
  // 工作台统计卡片（总设备/激活/在线/离线/今日告警）
  @observable statCards = {};
  @action
  setStatCards = data => this.statCards = data;
  getStatCards = () => {
    return this.fetch({
      url: apiUrl.WORKBENCH.STAT_CARDS,
      method: 'get',
      setState: this.setStatCards,
    });
  }

  // 待处理告警列表（点击可在地图定位）
  @observable pendingAlarms = [];
  @action
  setPendingAlarms = data => this.pendingAlarms = data;
  getPendingAlarms = () => {
    return this.fetch({
      url: apiUrl.WORKBENCH.PENDING_ALARMS,
      method: 'get',
      setState: this.setPendingAlarms,
    });
  }
}
